import { ProductionDeviationResponse } from "features/CenterContent/RoleContent/ProductionDeviation/types/responseSchema";
import { ProductionDeviationElement } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/ProductionDeviationElement";
import { FC } from "react";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import { Stack } from "shared/components/Spor";

type ProductionDeviationsListProps = {
  data: ProductionDeviationResponse[];
};

export const ProductionDeviationsList: FC<ProductionDeviationsListProps> = ({
  data,
}) => {
  if (data.length === 0)
    return <NoDataMessage reason="Det er ikke registrert noen hendelser" />;

  return (
    <Stack gap="18px">
      {data.map((productionDeviation) => (
        <ProductionDeviationElement
          key={productionDeviation.reference}
          productionDeviation={productionDeviation}
        />
      ))}
    </Stack>
  );
};
